import { initializeAnalytics } from "../src/analytics/analytics";
import { renderClientApp } from "../src/app/renderClientApp";
import "../src/i18n";
import "../src/index.css";

export { onRenderClient };

async function onRenderClient() {
  const root = document.getElementById("root");

  if (!root) {
    throw new Error("Missing #root element for client hydration.");
  }

  initializeAnalytics();
  await renderClientApp(root);
}
